module.exports = __webpack_public_path__ + "static/media/linkedinIcon.3c1f7766.svg";